module.exports = __webpack_public_path__ + "img/banner_teste_2.354e99f4.jpg";